import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a647df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-modal-father" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-father" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Carrinho")
], -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"32px"} }, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "products-container" }
const _hoisted_5 = {
  key: 0,
  class: "empty-cart-text"
}
const _hoisted_6 = { class: "total-cart" }
const _hoisted_7 = { class: "total-text" }
const _hoisted_8 = { class: "total-products-price" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"64px"} }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], { ref: "cartModal" }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values($setup.cartStore.cart.products), (item) => {
              return (_openBlock(), _createBlock($setup["CartProductCard"], {
                key: item.product.id,
                product: item.product,
                quantity: item.quantity,
                onAddToCart: (cartAmount) => $setup.cartStore.addToCart(item.product, cartAmount),
                onRemoveFromCart: () => $setup.cartStore.removeFromCart(item.product),
                onSetAmount: (cartAmount) => $setup.cartStore.setAmount(item.product, cartAmount)
              }, null, 8 /* PROPS */, ["product", "quantity", "onAddToCart", "onRemoveFromCart", "onSetAmount"]))
            }), 128 /* KEYED_FRAGMENT */)),
            (Object.keys($setup.cartStore.cart.products).length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Seu carrinho está vazio"))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode("Total: "),
            _createElementVNode("b", _hoisted_8, "R$ " + _toDisplayString($setup.FormatUtils.formatPrice($setup.cartStore.getTotalItemsPrice())), 1 /* TEXT */)
          ]),
          _hoisted_9,
          _createVNode($setup["CommonButton"], {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.cartStore.sendToSeller()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Enviar pedido para o representante comercial")
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}